module.exports = __webpack_public_path__ + "static/media/galerija_2022_0016.07034c6b.jpg";